// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Link, Icon, Badge } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { ExternalMinor } from '@shopify/polaris-icons';

import NoInstalledThemes from 'src/components/views/tools/integration/no-installed-themes';
import { getAppAdminFeatures } from 'src/helpers/features-helper';

import * as ThemeSetupActions from 'actions/theme-setup-actions';

type Props = {
  index: number,
  icon: number,
  name: number,
  appListingURL: string,
  description: string,
  instructionURL: string
};

type ComposedProps = Props & WithI18nProps;

type State = {
  enabled: boolean,
  activeNoInstalledThemes: boolean
};

class GemPagesCard extends Component<ComposedProps, State> {
  state = {
    enabled: false,
    activeNoInstalledThemes: false
  };

  componentDidMount() {
    const integrated = getAppAdminFeatures('integrateGemPages');
    if (integrated) {
      this.setState({ enabled: true });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { loading } = this.props;
    const { themes, loading: loadingNext } = nextProps;
    // Display
    if (loading === true && loadingNext === false && _.isEmpty(themes)) {
      this.handleChangeModal();
    }
  }

  render() {
    const { i18n, data = {}, index, loading, themeSetupV2, themeSetupV3 } = this.props;
    const { enabled, activeNoInstalledThemes } = this.state;
    const { icon, name, appListingURL, description, instructionURL } = data;

    return (
      <div className={index === 1 ? 'item middle' : 'item'}>
        <div className="item-header">
          <a
            className="Polaris-Link"
            href={appListingURL}
            target="_blank"
            rel="noopener noreferrer">
            <img className="icon" src={icon} alt={i18n.translate(name)} />
          </a>
        </div>
        {/* App name */}
        <p className="name">{i18n.translate(name)}</p>

        {/* App description */}
        <p className="description">{i18n.translate(description)}</p>

        {/*Enable/Disable app key*/}
        {(themeSetupV2 || themeSetupV3) && (
          <label className="BC-Checkbox-Status">
            <input type="checkbox" checked={enabled} onChange={this.handleChange} />
            <span />
          </label>
        )}

        {/* App instruction */}
        {/* <div className="instruction">
          {i18n.translate('AdminHTML.Integration.Integration.instruction', {
            t: (
              <Link external url={instructionURL}>
                {i18n.translate('AdminHTML.Integration.Integration.instruction_t', {
                  nt_name: i18n.translate(name)
                })}
              </Link>
            )
          })}
        </div> */}
        <div className="BC-Checkbox-Status__Wrapper">
          <div className="integration">
            <Badge status="info">
              <Link url={instructionURL} external>
                {i18n.translate('AdminHTML.Integration.Constants.integrationGuide')}
                <Icon source={ExternalMinor} />
              </Link>
            </Badge>
          </div>
        </div>

        {/* Submit button */}
        {(themeSetupV2 || themeSetupV3) && enabled ? (
          <span className="integrateGemPages">
            <Button primary onClick={this.handleIntegration} disabled={loading} loading={loading}>
              {i18n.translate('AdminHTML.Integration.Integration.runThemeIntegration')}
            </Button>
          </span>
        ) : (
          ''
        )}

        <NoInstalledThemes
          active={activeNoInstalledThemes}
          handleChange={this.handleChangeModal}
          handleContinue={this.runSetup}
        />
      </div>
    );
  }

  // Save yotpo app key
  handleIntegration = () => {
    const { integrateGemPages } = this.props;
    integrateGemPages();
  };

  // Change status
  handleChange = () => {
    this.setState(({ enabled }) => ({ enabled: !enabled }));
  };

  handleChangeModal = () => {
    this.setState(({ activeNoInstalledThemes }) => ({
      activeNoInstalledThemes: !activeNoInstalledThemes
    }));
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  integrateGemPages: () => dispatch(ThemeSetupActions.integrateGemPages(ownProps.i18n))
});

const mapStateToProps = state => {
  const themeSetupState = _.get(state, 'themeSetup', {});
  const integrateGemPagesLoading = _.get(themeSetupState, 'integrateGemPagesLoading', false);
  const integrateGemPagesThemes = _.get(themeSetupState, 'integrateGemPagesThemes', {});
  // Show/hide by themeSetupV2
  const themeSetupV2 = _.get(state.oauth, 'tenantApp.adminAppFeatures.themeSetupV2', false);
  const themeSetupV3 = _.get(state.oauth, 'tenantApp.settings.themeSetupV3.settings.enable', false);

  return {
    loading: integrateGemPagesLoading,
    themes: integrateGemPagesThemes,
    themeSetupV3,
    themeSetupV2
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(GemPagesCard));
